const ExchangesSection = () => (
  <section className="section light">
    <h2 className="section-title">Exchange Support</h2>

    <div className="exchange-grid">
      <div><strong>Live</strong><br/>Bitget</div>
      <div><strong>Roadmap</strong><br/>Binance, MEXC, OKX, Bybit</div>
    </div>
  </section>
);

export default ExchangesSection;

